(function () {
    'use strict';

    angular
        .module('jcsfApp')
        .factory('jcCenterService', jcCenterService);

    jcCenterService.$inject = ['$http', '$filter', 'modelTransformer', 'messaging', 'events', 'JCCenter'];

    function jcCenterService($http, $filter, modelTransformer, messaging, events, JCCenter) {
        var baseUrl = '/api/JCCenter/';
        var jcCenters = [];
        var dId = 0;
        var center = {};
        var service = {
            init: init,
            getjcCenters: getjcCenters
        };
        messaging.subscribe(events.message._GET_JCCENTER_LIST_, getjcCenters);
        messaging.subscribe(events.message._DELETE_JCCENTER_, deleteJCCenter);
        messaging.subscribe(events.message._GET_JCCENTER_, getJCCenter);
        messaging.subscribe(events.message._SAVE_JCCENTER_, saveJCCenter);

        return service;
        function init() {
            jcCenters = [];
            center = {};
        }

        function getjcCenters(clear) {
            if (clear === true) {
                jcCenters = [];
            }

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetList/';

            $http.get(baseUrl + url)
                .then(getjcCentersSuccessHandler, getjcCentersErrorHandler);

        }
        function getJCCenter(id) {

            dId = id;
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.get(baseUrl + 'Get/' + dId)
                .then(getJCCenterSuccessHandler, getJCCenterErrorHandler);

        }
        function deleteJCCenter(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'deleteJCCenter/' + id)
                .then(deleteJCCenterSuccessHandler, deleteJCCenterErrorHandler);
        }
        function saveJCCenter(src) {

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'saveJCCenter/', src)
                .then(saveJCCenterSuccessHandler, saveJCCenterErrorHandler);
        }
        function getjcCentersSuccessHandler(results) {

            if (results.data && results.data.length) {
                var result = [];
                angular.forEach(results.data, function (d) {
                    var dr = modelTransformer.transform(d, JCCenter);
                    result.push(dr);
                });
                jcCenters = result;
                messaging.publish(events.message._GET_JCCENTER_LIST_COMPLETE_, [jcCenters]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
                return jcCenters;
            } else {
                getjcCentersErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getJCCenterSuccessHandler(results) {
            if (results.data) {
                center = modelTransformer.transform(results.data, JCCenter);
                messaging.publish(events.message._GET_JCCENTER_COMPLETE_, [center]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                getJCCenterErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function deleteJCCenterSuccessHandler(results) {
            if (results) {
                var id = angular.toJson(results.data.JCCenterId);
                var ix = -1;
                var match = $filter('filter')(jcCenters, function (p) {
                    return Number(p.JCCenterId) === Number(id);
                })[0];
                if (match) {
                    ix = jcCenters.indexOf(match);
                }
                if (ix >= 0) {
                    jcCenters.splice(ix, 1);
                    messaging.publish(events.message._JCCENTER_LIST_UPDATED_, [jcCenters]);
                }
                messaging.publish(events.message._DELETE_JCCENTER_COMPLETE_, [id]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                deleteJCCenterErrorHandler({ data: { error_description: 'No Records Deleted' } });
            }
        }
        function saveJCCenterSuccessHandler(results) {
            if (results.data) {
                var result = results.data;
                center = updateOrAddJCCenter(result); 
                messaging.publish(events.message._SAVE_JCCENTER_COMPLETE_, [center]);
                messaging.publish(events.message._JCCENTER_LIST_UPDATED_, [jcCenters]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
                messaging.publish(events.message._SAVE_SUCCESS_);
            } else {
                saveJCCenterErrorHandler({ data: { error_description: 'No Records Saved' } });
            }
        }
        function updateOrAddJCCenter(result) {
            center = modelTransformer.transform(result, JCCenter);

            return center;
        }

        function getJCCenterErrorHandler(results) {
            messaging.publish(events.message._GET_JCCENTER_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get JCCenter from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function getjcCentersErrorHandler(results) {
            messaging.publish(events.message._GET_JCCENTER_LIST_FAILED);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get JCCenter List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function deleteJCCenterErrorHandler(results) {
            messaging.publish(events.message._DELETE_JCCENTER_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to Delete JCCenter from the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function saveJCCenterErrorHandler(results) {
            messaging.publish(events.message._SAVE_JCCENTER_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to save JCCenter to the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
    }
})();